const __RELATIVE_SOURCE_FILE__ /* __INJECTED__ */ = 'packages/patapp_web/src/config/liho/eCheckin/sections/PatientenVerfuegung.tsx';
import * as React from 'react';
import { forwardRef } from 'react';
import { useCIS4m } from '@cistec/common_web/modules/CIS4m/hooks';
import { useIntl } from 'react-intl';
import textMap from '../translations';
import { ECheckinSectionProps } from 'App/components/eCheckin/types';
import ECheckinSection from 'App/components/eCheckin/components/ECheckinSection';
import { YesNoField } from 'App/components/eCheckin/components/fields/YesNoField';
import { createFieldPath } from 'App/components/eCheckin/utils';
import { useText } from '@cistec/common_web/utils/intlUtils';

export const PatientenVerfuegung = forwardRef((props: ECheckinSectionProps, ref: any) => {
    const { path } = props;
    const title = useText(props.title);

    const PATH_DIREKTABRECHNUNG = createFieldPath(path, 'patientenVerfuegung');

    const { formatMessage } = useIntl();

    const eCheckinSectionRef = useCIS4m(ref);

    return (
        <ECheckinSection ref={eCheckinSectionRef} path={path} title={title}>
            <h1>{title}</h1>
            <YesNoField
                path={PATH_DIREKTABRECHNUNG}
                label={textMap.patientenVerfuegungQuestion}
                required={true}
                yesValue="YES"
                noValue="NO"
            />
        </ECheckinSection>
    );
});

PatientenVerfuegung.displayName = 'PatientenVerfuegung';

export default PatientenVerfuegung;
